import React from 'react';
import { User } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import GoogleLoginButton from './GoogleLoginButton';

// Import colors and fonts from existing design system
const colors = {
  accent: '#1e40af',
  accentHover: '#1e3a8a',
  accentLight: 'rgba(30, 64, 175, 0.1)',
  white: '#ffffff',
  gray50: '#f9f9f9',
  gray100: '#f3f3f3',
  gray200: '#e6e6e6',
  gray300: '#d1d1d1',
  gray500: '#8e8e8e',
  gray700: '#636363',
  gray900: '#333333',
};

const fontStyles = {
  fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
  heading: {
    fontWeight: 500,
    letterSpacing: '-0.03em',
  },
  body: {
    fontWeight: 400,
    letterSpacing: '-0.01em',
  },
  medium: {
    fontWeight: 500,
  },
};

const LoginPage = () => {
  const navigate = useNavigate();

  const handleEmailLogin = () => {
    navigate('/login/credentials');
  };

  // Do not override GoogleLoginButton's success handling so it can
  // call the AuthContext flow to set user + token before navigating.

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-6 py-12"
      style={{
        fontFamily: fontStyles.fontFamily,
        backgroundColor: colors.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '3rem 1.5rem',
      }}
    >
      <div
        className="w-full max-w-md mx-auto"
        style={{
          width: '100%',
          maxWidth: '400px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Header Section */}
        <div className="text-center mb-10">
          {/* Main Heading with inline logo */}
          <h1
            className="text-4xl font-bold mb-4 flex items-center justify-center"
            style={{
              color: colors.black,
              ...fontStyles.heading,
              lineHeight: '1.1',
            }}
          >
            Get started with
            <img src="/6.png" alt="SignPact Logo" className="h-12 ml-2" style={{marginTop: '4px'}} />
          </h1>

          {/* Subtitle */}
          
        </div>

        {/* Buttons Section */}
        <div className="space-y-4 mb-6">
          {/* Google Login Button */}
          <GoogleLoginButton 
            className="w-full"
          />

          {/* OR Divider */}
          <div className="relative flex items-center justify-center my-6">
            <div 
              className="border-t absolute w-full" 
              style={{ borderColor: colors.gray200 }}
            />
            <span 
              className="bg-white px-4 text-sm relative"
              style={{ 
                color: colors.gray500,
                fontSize: '14px',
              }}
            >
              OR
            </span>
          </div>

          {/* Email Login Button */}
          <button
            onClick={handleEmailLogin}
            className="w-full py-3 px-6 rounded-xl font-medium flex items-center justify-center"
            style={{
              backgroundColor: colors.white,
              color: colors.gray900,
              border: '1px solid #e6e6e6',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.2s ease',
              ...fontStyles.medium,
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f9f9f9';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = colors.white;
            }}
          >
            <User size={20} className="mr-2" />
            Continue with Email
          </button>
        </div>

        {/* Footer Section */}
        <div className="text-center">
          <p
            className="text-xs leading-relaxed"
            style={{
              color: colors.gray500,
              fontSize: '12px',
            }}
          >
            By clicking continue, you agree to our{' '}
            <Link
              to="/terms"
              className="underline hover:no-underline"
              style={{ color: colors.accent }}
            >
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link
              to="/privacy"
              className="underline hover:no-underline"
              style={{ color: colors.accent }}
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 